import axiosInstance from './axiosInstance';

const clean = (params) =>
  Object.fromEntries(Object.entries(params || {}).filter(([, v]) => v !== '' && v != null));

export const getProductsApi         = (params) => axiosInstance.get('/products', { params: clean(params) });
export const getFeaturedProductsApi = ()       => axiosInstance.get('/products/featured');
export const getProductBySlugApi    = (slug)   => axiosInstance.get(`/products/${slug}`);
export const createProductApi       = (data)   => axiosInstance.post('/products', data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateProductApi       = (id, data) => axiosInstance.put(`/products/${id}`, data);
export const deleteProductApi       = (id)     => axiosInstance.delete(`/products/${id}`);

// Reviews — send as multipart so images can be attached
export const addReviewApi           = (id, formData) =>
  axiosInstance.post(`/products/${id}/reviews`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });

export const markReviewHelpfulApi   = (productId, reviewId) =>
  axiosInstance.patch(`/products/${productId}/reviews/${reviewId}/helpful`);

export const getSearchSuggestionsApi = (q) => axiosInstance.get('/products/search/suggestions', { params: { q } });
